module.exports = __webpack_public_path__ + "static/media/04-0201.d9366767.png";